import { requestApi, postWithFile } from '@/utils/request'

export const getSettings = () =>
  requestApi({
    method: 'get',
    endpoint: '/v2/setting-dashboard',
  })

export const getUsers = ({ params }) =>
  requestApi({
    method: 'get',
    endpoint: '/v2/users',
    params,
  })

export function createUser({ data }) {
  return requestApi({
    method: 'post',
    endpoint: '/v2/create-user',
    data,
  })
}

export function uploadAddBlackList(payload) {
  return postWithFile({
    method: 'post',
    endpoint: '/v2/upload-add-blacklist',
    data: payload,
  })
}

export function uploadDeleteBlacklist(payload) {
  return postWithFile({
    method: 'post',
    endpoint: '/v2/upload-delete-blacklist',
    data: payload,
  })
}

export function activeUser({ id, data }) {
  return requestApi({
    method: 'put',
    endpoint: `/v2/active-user/${id}`,
    data,
  })
}

export function getSchedules({ params }) {
  return requestApi({
    method: 'get',
    endpoint: '/v2/time/schedules',
    params,
  })
}

export function createSchedule({ data }) {
  return requestApi({
    method: 'post',
    endpoint: '/v2/time/create-schedule',
    data,
  })
}

export function updateSchedule({ scheduleId, data }) {
  return requestApi({
    method: 'put',
    endpoint: `/v2/time/schedules/${scheduleId}`,
    data,
  })
}

export function deleteSchedule(id) {
  return requestApi({
    method: 'delete',
    endpoint: `/v2/time/schedules/${id}`,
  })
}

export function getEvents({ params }) {
  return requestApi({
    method: 'get',
    endpoint: '/v2/time/schedule-periods',
    params,
  })
}

export function createEvent({ data }) {
  return requestApi({
    method: 'post',
    endpoint: '/v2/time/create-period',
    data,
  })
}

export function editEvent({ id, data }) {
  return requestApi({
    method: 'put',
    endpoint: `/v2/time/schedule-periods/${id}`,
    data,
  })
}

export function deleteEvent({ id }) {
  return requestApi({
    method: 'delete',
    endpoint: `/v2/time/schedule-periods/${id}`,
  })
}

// api on setting page
export function getAttributes({ params }) {
  return requestApi({
    method: 'get',
    endpoint: '/v2/fields',
    params,
  })
}

export function getAttribute(fieldId) {
  return requestApi({
    method: 'get',
    endpoint: `/v2/field/${fieldId}`,
  })
}

export function createAttribute({ data }) {
  return requestApi({
    method: 'post',
    endpoint: '/v2/field',
    data,
  })
}

export function editAttribute({ id, data }) {
  return requestApi({
    method: 'put',
    endpoint: `/v2/field/${id}`,
    data,
  })
}

export function deleteAttribute({ id }) {
  return requestApi({
    method: 'delete',
    endpoint: `/v2/field/${id}`,
  })
}

export function getGroups({ params }) {
  //target=user
  return requestApi({
    method: 'get',
    endpoint: '/v2/groups',
    params,
  })
}

export function createGroup({ data }) {
  return requestApi({
    method: 'post',
    endpoint: '/v2/group',
    data,
  })
}

export function updateGroup({ data }) {
  return requestApi({
    method: 'put',
    endpoint: `/v2/updateGroup`,
    data,
  })
}

export function deleteGroup({ id }) {
  return requestApi({
    method: 'delete',
    endpoint: `/v2/group/${id}`,
  })
}

export function getTicketStatus() {
  return requestApi({
    method: 'get',
    endpoint: '/status',
  })
}

export function getCities() {
  return requestApi({
    method: 'get',
    endpoint: '/cities',
  })
}

export function getOrganizes({ params }) {
  return requestApi({
    method: 'get',
    endpoint: '/v2/organizes',
    params,
  })
}

export function getAllOrganizes() {
  return requestApi({
    method: 'get',
    endpoint: '/v2/all-organize',
  })
}

export function createOrganize({ data }) {
  return requestApi({
    method: 'post',
    endpoint: '/v2/organize',
    data,
  })
}

export function deleteOrganize({ id }) {
  return requestApi({
    method: 'delete',
    endpoint: `/v2/organize/${id}`,
  })
}

export function getOrganizationDetail({ id }) {
  return requestApi({
    method: 'get',
    endpoint: `/v2/organize/${id}`,
  })
}

export function updateOrganization({ id, data }) {
  return requestApi({
    method: 'put',
    endpoint: `/v2/organize/${id}`,
    data,
  })
}

export function getTypeTicket({ params }) {
  return requestApi({
    method: 'get',
    endpoint: '/v2/types',
    params,
  })
}

export function createTypeTicket({ data }) {
  return requestApi({
    method: 'post',
    endpoint: '/v2/type',
    data,
  })
}

export function editTypeTicket({ id, data }) {
  return requestApi({
    method: 'put',
    endpoint: `/v2/type/${id}`,
    data,
  })
}

export function deleteTypeTicket({ id }) {
  return requestApi({
    method: 'delete',
    endpoint: `/v2/type/${id}`,
    // endpoint: '/v2/all-organize',
  })
}

export function getTicketTemplate({ params }) {
  return requestApi({
    method: 'get',
    endpoint: '/v2/templates',
    params,
  })
}

export function createTicketTemplate({ data }) {
  return requestApi({
    method: 'post',
    endpoint: '/v2/template',
    data,
  })
}

export function editTicketTemplate({ id, data }) {
  return requestApi({
    method: 'put',
    endpoint: `/v2/template/${id}`,
    data,
  })
}

export function deleteTicketTemplate({ id }) {
  return requestApi({
    method: 'delete',
    endpoint: `/v2/template/${id}`,
  })
}

export function getTicketPriorityLevel({ params }) {
  return requestApi({
    method: 'get',
    endpoint: '/v2/priorities',
    params,
  })
}

export function createTicketPriorityLevel({ data }) {
  return requestApi({
    method: 'post',
    endpoint: '/v2/priority',
    data,
  })
}

export function editTicketPriorityLevel({ id, data }) {
  return requestApi({
    method: 'put',
    endpoint: `/v2/priority/${id}`,
    data,
  })
}

export function deleteTicketPriorityLevel({ id }) {
  return requestApi({
    method: 'delete',
    endpoint: `/priority/${id}`,
  })
}
export function getDistricts({ params }) {
  return requestApi({
    method: 'get',
    endpoint: 'districts',
    params,
  })
}

export function getDistrictsByCityId({ city_id }) {
  return requestApi({
    method: 'get',
    endpoint: `districts?city_id=${city_id}`,
  })
}
export function getChatConfig() {
  return requestApi({
    method: 'get',
    endpoint: '/v2/chat-config',
  })
}

export function updateChatConfig({ data }) {
  return requestApi({
    method: 'put',
    endpoint: `/v2/chat-config`,
    data,
  })
}

// Setting SwitchBoard

export function getPriorities() {
  return requestApi({
    method: 'get',
    endpoint: '/all-priority',
  })
}

export function createTemplate({ data }) {
  return requestApi({
    method: 'post',
    endpoint: '/v2/core/template',
    data,
  })
}

export function editTemplate({ id, data }) {
  return requestApi({
    method: 'put',
    endpoint: `/v2/core/template/${id}`,
    data,
  })
}

export function deleteTemplate({ id }) {
  return requestApi({
    method: 'delete',
    endpoint: `/v2/core/template/${id}`,
  })
}

export function getSettingBlacklist({ params }) {
  return requestApi({
    method: 'get',
    endpoint: '/v2/all-blacklists',
    params,
  })
}

export function createSettingBlacklist({ data }) {
  return requestApi({
    method: 'post',
    endpoint: '/v2/post-blacklist',
    data,
  })
}

export function editSettingBlacklist({ data }) {
  return requestApi({
    method: 'put',
    endpoint: `/v2/update-blacklist`,
    data,
  })
}

export function deleteSettingBlacklist({ id }) {
  return requestApi({
    method: 'post',
    endpoint: `/v2/delete-blacklist/${id}`,
  })
}

export function deleteSettingManyBlacklist(blacklistIds) {
  return requestApi({
    method: 'post',
    endpoint: `/v2/delete-many-blacklist`,
    data: {
      ids: blacklistIds,
    },
  })
}

export const getSmsTemplates = (params) => {
  const options = {
    method: 'get',
    endpoint: '/v2/core/templates/sms',
  }

  if (params) {
    options.params = params
  }

  return requestApi(options)
}

export const getZnsTemplates = (params) => {
  const options = {
    method: 'get',
    endpoint: '/v2/core/templates/zns',
  }

  if (params) {
    options.params = params
  }

  return requestApi(options)
}

export const getChatTemplates = (params) => {
  const options = {
    method: 'get',
    endpoint: '/v2/core/templates/chat',
  }

  if (params) {
    options.params = params
  }

  return requestApi(options)
}

export const getWhatsappTemplates = (params) => {
  const options = {
    method: 'get',
    endpoint: '/v2/core/templates/whatsapp',
  }

  if (params) {
    options.params = params
  }

  return requestApi(options)
}

export const getEmailTemplates = (params) => {
  const options = {
    method: 'get',
    endpoint: `/v2/core/templates/email`,
  }

  if (params) {
    options.params = params
  }

  return requestApi(options)
}

export const getEmailAccounts = () =>
  requestApi({
    method: 'get',
    endpoint: '/v2/email/accounts',
  })

export const getSmartViews = (params) => {
  return requestApi({
    method: 'get',
    endpoint: '/v2/smart-view',
    params,
  })
}

export const copySmartView = (viewId) => {
  return requestApi({
    method: 'post',
    endpoint: `/v2/smart-view/${viewId}`,
  })
}

export const getSmartViewDetail = (viewId) =>
  requestApi({
    method: 'get',
    endpoint: `v2/smart-view/${viewId}`,
  })

export const getTags = (params) => {
  const options = {
    method: 'get',
    endpoint: `/v2/group-tag-customer`,
  }

  if (params) {
    options.params = params
  }

  return requestApi(options)
}

export const createGroupTag = (payload) =>
  requestApi({
    method: 'post',
    endpoint: '/v2/group-tag-customer',
    data: payload,
  })

export const updateGroupTag = (id, payload) =>
  requestApi({
    method: 'put',
    endpoint: `/v2/group-tag-customer/${id}`,
    data: payload,
  })

export const deleteGroupTag = (id) =>
  requestApi({
    method: 'delete',
    endpoint: `/v2/group-tag-customer/${id}`,
  })

export const getGroupsByTenantId = async (tenantId, params) => {
  return requestApi({
    method: 'get',
    endpoint: `/v2/settings/${tenantId}/groups`,
    params,
  })
}

export const getUsersByTenantId = async (tenantId, params) => {
  return requestApi({
    method: 'get',
    endpoint: `/v2/admin/settings/${tenantId}/users`,
    params,
  })
}

export const getAllDomains = async () => {
  return requestApi({
    method: 'get',
    endpoint: '/v2/admin/settings/accounts-all',
  })
}
